import React from 'react';
import { Route } from 'react-router-dom';
import FurnishingRequestsContainer from './FurnishingRequests';
import { APP_ROUTES } from '../../../shared/config/routes-config';

export const FurnishingRequestsModule = () => {
  return (
    <Route
      exact
      path={APP_ROUTES.FURNISHING_MANAGEMENT_MODULE.CHILDREN?.REQUESTS.FULL_PATH}
      component={FurnishingRequestsContainer}
    />
  );
};
